import { on } from "@ember/modifier";
import { t } from "ember-intl";
import GButton from "glesys-controlpanel/components/g-button";
import dateFromNow from "glesys-controlpanel/helpers/date-from-now";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <div
    class="w-full mb-4 p-6 lg:p-5 px-6 border border-gray-200 bg-white rounded flex flex-col lg:flex-row lg:items-center lg:justify-between"
    {{mergeClasses}}
    ...attributes
  >
    <div class="flex flex-col lg:flex-row gap-4 lg:gap-10">
      <div>
        <div class="text-sm text-gray-500">{{t "dashboard.invites.card.sender"}}</div>
        <div class="text-base text-black" data-test-invite-card-sender>{{@invite.sender}}</div>
      </div>
      <div>
        <div class="text-sm text-gray-500">{{t "dashboard.invites.card.organization"}}</div>
        <div class="text-base text-black" data-test-invite-card-organization>
          {{#if @invite.organizationName}}
            {{@invite.organizationName}}
            <span class="text-gray-600">({{@invite.organizationId}})</span>
          {{else}}
            {{@invite.organizationId}}
          {{/if}}
        </div>
      </div>
      <div>
        <div class="text-sm text-gray-500">{{t "dashboard.invites.card.received"}}</div>
        <div class="text-base text-black" data-test-invite-card-received>{{dateFromNow @invite.created}}</div>
      </div>
    </div>

    <div class="mt-4 lg:mt-0">
      <GButton
        data-test-invite-accept={{@invite.id}}
        @color="blue"
        @loading={{@task.isRunning}}
        {{on "click" @task.perform}}
      >
        {{t "button.accept"}}
      </GButton>
    </div>
  </div>
</template>
